import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Field, WatchField, useWatch } from '../../form'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import {
  unitItems,
  alvPercentageItems,
  renderAlvPercentageItems
} from '../../utils/invoice.utils'
import FontAwesome from 'react-fontawesome'
import mobileView from '../../utils/mobile.utils'
import { Grid } from '@material-ui/core'
import { Translation, useTranslation } from 'react-i18next'
import {
  calculateTaxFreeSum,
  calculateTotalSum
} from '../../utils/invoice.utils'
import SumField from './sumField.component'
import { GenericNumberInput } from '../../utils/numberFormat'
import { extractCostTranslation } from '../../utils/translations.utils'

const styles = (theme) => ({
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    padding: '0px 6px 18px',
    verticalAlign: 'bottom'
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    padding: '0px 6px',
    marginTop: '0px !important',
    marginBottom: '8px !important',
    verticalAlign: 'top'
  },
  gridItem: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    padding: '1px 3px'
  },
  select: {
    minWidth: 20,
    fontSize: '14px',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  select1: {
    minWidth: 20,
    fontSize: '14px',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif',
    marginTop: '0px !important',
    marginBottom: '8px !important'
  },
  textField: {
    marginTop: theme.spacing(3),
    minWidth: 80,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  textField1: {
    marginTop: theme.spacing(3),
    minWidth: 50,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  textField2: {
    marginTop: theme.spacing(3),
    border: '1px solid gray',
    minWidth: 30,
    fontFamily: 'Poppins, sans-serif'
  },
  dateField: {
    marginTop: theme.spacing(3),
    minWidth: 75,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  resize: {
    fontSize: '14px'
  },
  textArea: {
    marginTop: theme.spacing(3),
    minWidth: 290,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  textAreaMobile: {
    marginTop: theme.spacing(3),
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  label: {
    [theme.breakpoints.down('350')]: {
      marginTop: 45
    }
  }
})

const InvoiceInputRow = ({
  classes,
  index,
  copy,
  autoFocusIndex,
  description,
  startDate,
  endDate,
  quantity,
  unit,
  quantityPrice,
  vatPercent,
  sumTaxFree,
  sumWithVAT,
  invoice_expense_id,
  invoice_allowance_id,
  remove,
  setValue,
  getValues,
  control,
  maxVat,
  shouldDisableVat0,
  vat_selection
}) => {
  const { t } = useTranslation()
  //gets the values but doesn't need to subscribe to changes
  const rowIds = useWatch({
    fields: [invoice_allowance_id, invoice_expense_id],
    control,
    disabled: true
  })

  const fieldsToWatch = [
    sumWithVAT,
    quantity,
    quantityPrice,
    vatPercent,
    'invoice_price_selection'
  ]

  const isAllowance = rowIds[invoice_allowance_id]
    ? rowIds[invoice_allowance_id].toString() !== '-1'
    : false

  const isExpense = rowIds[invoice_expense_id]
    ? rowIds[invoice_expense_id].toString() !== '-1'
    : false

  const isInvoiceItem = !isAllowance && !isExpense

  const isAllowanceOrExpenseRow = isAllowance || isExpense

  const description_field = getValues(`rows.${index}.description`)

  return mobileView ? (
    _createInvoiceInputRowMobile(
      classes,
      index,
      copy,
      autoFocusIndex,
      description,
      startDate,
      endDate,
      quantity,
      unit,
      quantityPrice,
      vatPercent,
      sumTaxFree,
      sumWithVAT,
      invoice_expense_id,
      invoice_allowance_id,
      remove,
      setValue,
      isAllowanceOrExpenseRow,
      control,
      fieldsToWatch,
      isExpense,
      isAllowance,
      maxVat,
      description_field,
      shouldDisableVat0,
      vat_selection
    )
  ) : (
    <TableRow>
      <TableCell
        className={classes.tablecell}
        key={index}
        style={{ paddingLeft: 10 }}
      >
        <Field
          name={description}
          inputType="textfield"
          autoFocus={parseInt(autoFocusIndex) > 0 && !copy}
          className={classNames(classes.textArea, classes.resize)}
          disabled={isAllowanceOrExpenseRow}
          control={control}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
          displayValue={
            isAllowanceOrExpenseRow
              ? () => extractCostTranslation(t, description_field)
              : null
          }
        />
      </TableCell>
      <TableCell
        className={classes.tablecell}
        style={{ width: '1px', display: 'none' }}
      >
        <Field
          name={invoice_expense_id}
          className={classNames(classes.textArea, classes.resize)}
          inputType="textfield"
          disabled={isAllowanceOrExpenseRow}
          control={control}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        ></Field>
      </TableCell>
      <TableCell
        className={classes.tablecell}
        style={{ width: '1px', display: 'none' }}
      >
        <Field
          name={invoice_allowance_id}
          className={classNames(classes.textArea, classes.resize)}
          inputType="textfield"
          disabled={isAllowanceOrExpenseRow}
          control={control}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        ></Field>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '90px' }}>
        <WatchField fields={`rows.${index}.end_date`} control={control}>
          {(fields) => {
            return (
              <Field
                name={startDate}
                className={classNames(classes.dateField, classes.resize)}
                inputType="datepicker"
                maxDate={fields[`rows.${index}.end_date`]}
                disabled={isAllowanceOrExpenseRow}
                control={control}
                helperTextStyle={{ marginTop: '0px', height: '0px' }}
              />
            )
          }}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '90px' }}>
        <WatchField fields={`rows.${index}.start_date`} control={control}>
          {(fields) => (
            <Field
              name={endDate}
              className={classNames(classes.dateField, classes.resize)}
              inputType="datepicker"
              minDate={fields[`rows.${index}.start_date`]}
              disabled={isAllowanceOrExpenseRow}
              control={control}
              helperTextStyle={{ marginTop: '0px', height: '0px' }}
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '80px' }}>
        <Field
          name={quantity}
          disabled={isAllowanceOrExpenseRow}
          inputType="textfield"
          className={classNames(classes.textField1, classes.resize)}
          inputComponent={GenericNumberInput}
          control={control}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        />
      </TableCell>
      <TableCell className={classes.tablecell1} style={{ width: '70px' }}>
        <div style={{ marginTop: '-8px', marginBottom: '0px' }}>
          <Field
            name={unit}
            disabled={isAllowanceOrExpenseRow}
            className={classes.select1}
            inputType="select"
            control={control}
          >
            {unitItems}
          </Field>
        </div>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '50px' }}>
        <Field
          name={quantityPrice}
          disabled={isAllowanceOrExpenseRow}
          inputType="textfield"
          className={classNames(classes.textField, classes.resize)}
          inputComponent={GenericNumberInput}
          control={control}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '70px' }}>
        <VatPercent
          classes={classes}
          vatPercent={vatPercent}
          isAllowanceOrExpenseRow={isAllowanceOrExpenseRow}
          setValue={setValue}
          isAllowance={isAllowance}
          control={control}
          maxVat={maxVat}
          shouldDisableVat0={shouldDisableVat0}
          isInvoiceItem={isInvoiceItem}
          vat_selection={vat_selection}
          fieldsToWatch={fieldsToWatch}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '70px' }}>
        <WatchField
          fields={fieldsToWatch}
          control={control}
          disabled={isExpense}
        >
          {(fields) => (
            <SumField
              name={sumTaxFree}
              setValue={setValue}
              className={classNames(
                classes.textField,
                classes.resize,
                classes.label
              )}
              control={control}
              watchValue={calculateTaxFreeSum(
                fields.invoice_price_selection,
                fields[quantity],
                fields[quantityPrice],
                fields[vatPercent],
                isExpense,
                isAllowance
              )}
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '70px' }}>
        <WatchField
          fields={fieldsToWatch}
          control={control}
          disabled={isExpense}
        >
          {(fields) => (
            <SumField
              name={sumWithVAT}
              setValue={setValue}
              className={classNames(
                classes.textField,
                classes.resize,
                classes.label
              )}
              control={control}
              watchValue={
                // KAS-356 When invoice row is expense, don't need to calculate the sumWithVAT
                // calculation expense sumWithVAT is done at Costs and expenses tab
                isExpense
                  ? fields[sumWithVAT].toString().replace(/,/g, '.')
                  : calculateTotalSum(
                      fields.invoice_price_selection,
                      fields[quantity],
                      fields[quantityPrice],
                      fields[vatPercent],
                      isExpense,
                      isAllowance
                    )
              }
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell}>
        <IconButton
          style={{ marginTop: 0 }}
          aria-label="Delete"
          onClick={() => remove(index)}
          key={index}
        >
          <FontAwesome
            name="window-close"
            style={{
              color: '#F67131'
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const _createInvoiceInputRowMobile = (
  classes,
  index,
  copy,
  autoFocusIndex,
  description,
  startDate,
  endDate,
  quantity,
  unit,
  quantityPrice,
  vatPercent,
  sumTaxFree,
  sumWithVAT,
  invoice_expense_id,
  invoice_allowance_id,
  remove,
  setValue,
  isAllowanceOrExpenseRow,
  control,
  fieldsToWatch,
  isExpense,
  isAllowance,
  maxVat,
  description_field,
  shouldDisableVat0,
  isInvoiceItem,
  vat_selection
) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel-body">
          <Grid container>
            <Grid item className={classes.gridItem} key={index} xs={12}>
              {parseInt(autoFocusIndex) > 0 && !copy ? (
                <Field
                  name={description}
                  inputType="textfield"
                  autoFocus
                  className={classNames(classes.textAreaMobile, classes.resize)}
                  disabled={isAllowanceOrExpenseRow}
                  label={t('invoice.table')}
                  control={control}
                  displayValue={
                    isAllowanceOrExpenseRow
                      ? () => extractCostTranslation(t, description_field)
                      : null
                  }
                />
              ) : (
                <Field
                  name={description}
                  inputType="textfield"
                  className={classNames(classes.textAreaMobile, classes.resize)}
                  disabled={isAllowanceOrExpenseRow}
                  label={t('invoice.table')}
                  control={control}
                  displayValue={
                    isAllowanceOrExpenseRow
                      ? () => extractCostTranslation(t, description_field)
                      : null
                  }
                />
              )}
            </Grid>
            <Grid
              item
              className={classes.gridItem}
              style={{ width: '1px', display: 'none' }}
            >
              <Field
                name={invoice_expense_id}
                className={classNames(classes.textArea, classes.resize)}
                inputType="textfield"
                disabled={isAllowanceOrExpenseRow}
                control={control}
              ></Field>
            </Grid>
            <Grid
              item
              className={classes.gridItem}
              style={{ width: '1px', display: 'none' }}
            >
              <Field
                name={invoice_allowance_id}
                className={classNames(classes.textArea, classes.resize)}
                inputType="textfield"
                disabled={isAllowanceOrExpenseRow}
                control={control}
              ></Field>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <WatchField fields={`rows.${index}.end_date`} control={control}>
                {(fields) => (
                  <Field
                    name={startDate}
                    className={classNames(classes.dateField, classes.resize)}
                    inputType="datepicker"
                    maxDate={fields[`rows.${index}.end_date`]}
                    label={t('invoice.table2')}
                    disabled={isAllowanceOrExpenseRow}
                    control={control}
                  />
                )}
              </WatchField>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <WatchField fields={`rows.${index}.start_date`} control={control}>
                {(fields) => (
                  <Field
                    name={endDate}
                    className={classNames(classes.dateField, classes.resize)}
                    inputType="datepicker"
                    minDate={fields[`rows.${index}.start_date`]}
                    label={t('invoice.table3')}
                    disabled={isAllowanceOrExpenseRow}
                    control={control}
                  />
                )}
              </WatchField>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <div style={{ paddingTop: '8px' }}>
                <Field
                  name={quantity}
                  disabled={isAllowanceOrExpenseRow}
                  inputType="textfield"
                  inputComponent={GenericNumberInput}
                  className={classNames(classes.textField1, classes.resize)}
                  label={t('invoice.table4')}
                  control={control}
                />
              </div>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <Field
                name={unit}
                disabled={isAllowanceOrExpenseRow}
                className={classes.select}
                inputType="select"
                label={t('invoice.table5')}
                control={control}
              >
                {unitItems}
              </Field>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <div style={mobileView ? { paddingTop: '0px' } : '8px'}>
                <Field
                  name={quantityPrice}
                  disabled={isAllowanceOrExpenseRow}
                  inputType="textfield"
                  inputComponent={GenericNumberInput}
                  className={classNames(classes.textField, classes.resize)}
                  label={t('invoice.table6')}
                  control={control}
                />
              </div>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <VatPercent
                classes={classes}
                vatPercent={vatPercent}
                isAllowanceOrExpenseRow={isAllowanceOrExpenseRow}
                setValue={setValue}
                isAllowance={isAllowance}
                control={control}
                maxVat={maxVat}
                label={t('invoice.table7')}
                shouldDisableVat0={shouldDisableVat0}
                isInvoiceItem={isInvoiceItem}
                vat_selection={vat_selection}
                fieldsToWatch={fieldsToWatch}
              />
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <WatchField
                fields={fieldsToWatch}
                control={control}
                disabled={isExpense}
              >
                {(fields) => (
                  <SumField
                    name={sumTaxFree}
                    setValue={setValue}
                    label={t('invoice.table8')}
                    labelStyle={{
                      letterSpacing: '-0.8px',
                      whiteSpace: 'nowrap'
                    }}
                    className={classNames(
                      classes.textField,
                      classes.resize,
                      classes.label
                    )}
                    control={control}
                    watchValue={calculateTaxFreeSum(
                      fields.invoice_price_selection,
                      fields[quantity],
                      fields[quantityPrice],
                      fields[vatPercent],
                      isExpense,
                      isAllowance
                    )}
                  />
                )}
              </WatchField>
            </Grid>
            <Grid item className={classes.gridItem} xs={6}>
              <WatchField
                fields={fieldsToWatch}
                control={control}
                disabled={isExpense}
              >
                {(fields) => (
                  <SumField
                    name={sumWithVAT}
                    label={t('invoice.table10')}
                    setValue={setValue}
                    className={classNames(
                      classes.textField,
                      classes.resize,
                      classes.label
                    )}
                    control={control}
                    watchValue={
                      // KAS-356 When invoice row is expense, don't need to calculate the sumWithVAT
                      // calculation expense sumWithVAT is done at Costs and expenses tab
                      isExpense
                        ? fields[sumWithVAT].toString().replace(/,/g, '.')
                        : calculateTotalSum(
                            fields.invoice_price_selection,
                            fields[quantity],
                            fields[quantityPrice],
                            fields[vatPercent],
                            isExpense,
                            isAllowance
                          )
                    }
                  />
                )}
              </WatchField>
            </Grid>
            <Grid item className={classes.gridItem} xs={12}>
              <IconButton
                style={{ marginTop: 20 }}
                aria-label="Delete"
                onClick={() => remove(index)}
                key={index}
              >
                <FontAwesome
                  name="window-close"
                  style={{
                    color: '#F67131',
                    marginRight: 10
                  }}
                />
                <span>{t('invoice.table9')}</span>
              </IconButton>
            </Grid>
          </Grid>
          <hr style={{ margin: 0 }} />
        </div>
      )
    }}
  </Translation>
)

const VatPercent = ({
  classes,
  vatPercent,
  setValue,
  isAllowance,
  control,
  maxVat,
  label,
  isInvoiceItem,
  shouldDisableVat0,
  fieldsToWatch
}) => {
  React.useEffect(() => {
    if (isAllowance) {
      setValue(vatPercent, maxVat)
    }
  }, [isAllowance, maxVat])
  return (
    <WatchField fields={fieldsToWatch} control={control}>
      {(fields) => (
        <Field
          name={vatPercent}
          disabled={true}
          className={classNames(classes.textField2, classes.resize)}
          inputType="textfield"
          control={control}
          label={label}
          displayValue={fields[vatPercent].toString().replace('.', ',')}
          watchValue={maxVat}
        >
          {shouldDisableVat0 && isInvoiceItem
            ? renderAlvPercentageItems(shouldDisableVat0, isInvoiceItem)
            : alvPercentageItems}
        </Field>
      )}
    </WatchField>
  )
}

InvoiceInputRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvoiceInputRow)
